import React from 'react';
import { Box, Typography, Alert, Accordion, AccordionSummary, AccordionDetails, List, ListItem, FormControlLabel, Checkbox } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const NOPIG_FILTERS = {
  'ru-mat': 'Русские матерные слова',
  'ru-bad': 'Русские ругательства (не матерные)',
  'en-bad': 'Английские ругательства',
  'ru-mat-regex': 'Замаскированные матерные (regex)',
  'en-bad-regex': 'Замаскированные английские ругательства (regex)'
};

const FILTER_CATEGORIES = {
  'Матерные (чистые)': ['ru-mat'],
  'Матерные (маски)': ['ru-mat-regex'],
  'Русские bad': ['ru-bad'],
  'Английские bad': ['en-bad'],
  'Английские bad (regex)': ['en-bad-regex']
};

const NopigSettings = ({ settings, onSettingsChange }) => {
  const activeFilters = settings.filter || [];
  const handleChange = (filterName, checked) => {
    const newList = checked
      ? [...activeFilters, filterName]
      : activeFilters.filter(f => f !== filterName);
    onSettingsChange({ ...settings, filter: newList });
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        Настройки фильтра ругательств (nopig)
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Выберите категории ругательств для удаления сообщений.
      </Alert>
      {Object.entries(FILTER_CATEGORIES).map(([category, filters]) => (
        <Accordion key={category} sx={{ mb: 1 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>{category}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List dense>
              {filters.map(name => (
                <ListItem key={name} disablePadding>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={activeFilters.includes(name)}
                        onChange={e => handleChange(name, e.target.checked)}
                        color="primary"
                      />
                    }
                    label={NOPIG_FILTERS[name]}
                  />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default NopigSettings; 